import Vue from 'vue';

export default new Vue({
  data: {},
  methods: {
    /**
     * @description
     * Load list of persons (OSOBA) which needs to be manualy approved
     *
     * @returns {Promise<clientListItem[]>}
     */
    async getManualSyncList(rawParams) {
      const params = {
        qLastName: rawParams.qLastName || undefined,
        qFirstName: rawParams.qFirstName || undefined,
        qPesel: rawParams.qPesel || undefined,
        qCity: rawParams.qCity || undefined,
        // qStreet: rawParams.qStreet || undefined,
        // qZgodaNpdo: rawParams.qZgodaNpdo || undefined,
        // qZgodaNprd: rawParams.qZgodaNprd || undefined,
        // qZgodaNoih: rawParams.qZgodaNoih || undefined,
        // qZgodaEmail: rawParams.qZgodaEmail || undefined,
        // qApplicableLoyaltyCard: rawParams.qApplicableLoyaltyCard || undefined,
        // qStatus: rawParams.qStatus || 'active',
        sortOrder: rawParams.sortOrder || undefined,
        orderBy: rawParams.orderBy || undefined,
        offset: rawParams.offset || 0,
        pageSize: rawParams.pageSize || 10,
      };
      return await this.$http.get('/api/osoba/manual', { params })
        .then(response => response);
    },
    /**
     * @description
     * Load details of person (OSOBA) which needs to be manualy approved
     *
     * @returns {Promise<clientListItem[]>}
     */
    async getManualSyncDetails(params) {
      return await this.$http.get(`/api/osoba/manual/${params.osobaId}/${params.branchId}`)
        .then(response => response);
    },
    /**
     * @description
     * Approve manual sync for given person
     *
     * @returns {Promise<void>}
     */
    async approveManualSync(params) {
      return await this.$http.post(`/api/osoba/manual-approve/${params.osobaId}/${params.branchId}`, params.data)
        .then(response => response);
    },

    /**
     * When system thinks person is applicable for existing client but user wants to create new client from this person
     */
    async splitPersonClient(params) {
      return await this.$http.post(`/api/osoba/manual-split/${params.osobaId}/${params.branchId}`)
        .then(response => response);
    },

  }
});